import { gql } from "@apollo/client"

export const UPDATE_USER_NOTIFY_VIA_EMAIL_ENABLED = gql`
  mutation updateNotifyViaEmailEnabled($enabled: Boolean!) {
    updateNotifyViaEmailEnabled(enabled: $enabled) {
      success
    }
  }
`
